import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';

class Select extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = { selected: this.getDefaultSelection() };
    }

    /**
     * componentWillReceiveProps has been deprecate since React 16.3.
     * It needs to be replaced with getDerivedStateFromProps if we update
     * to React 16.3+
     */
    componentWillReceiveProps(nextProps) {
        if (nextProps.defaultSelection !== this.props.defaultSelection) {
            this.setState({ selected: nextProps.defaultSelection });
        }
    }

    getDefaultSelection() {
        const { defaultSelection } = this.props;
        return defaultSelection >= 0 ? defaultSelection : 0;
    }

    handleClick(index, option, event) {
        this.setState({ selected: index });
        this.props.onChange(option);
        event.preventDefault();
        event.stopPropagation();
    }

    handleChange(event) {
        let index = null;
        const { target: { value: eventValue } } = event;
        const selectedValue = eventValue && eventValue.toString();
        const { options, onChange } = this.props;
        index = options.map(({ value, label }) => (value || label)).indexOf(selectedValue);

        if (index !== null) {
            /**
             * first option value in the dropdown is -1, option[-1] returns undefined,
             * so we need to reset it to 0 to avoid array out of bounds exception.
             * We can't setState selected to 0 directly, since setState({selected: -1}) will trigger
             * companonent rerender, in app/espnapp/schedule/ScheduleCategorySection.js which is
             * what we expected
             */
            const option = index > 0 ? options[index] : options[0];
            this.setState({ selected: index });
            onChange(option);
        }
    }

    render() {
        const { options = [], menuSizeClass, name } = this.props;
        const { selected } = this.state;
        const menuClassName = classnames('dropdown-menu', menuSizeClass);
        const selectedOption = selected > 0 ? options[selected] : options[0];

        return (
            <span className="dropdown-wrapper-container">
                <div className="dropdown-wrapper display-desktop hoverable" data-behavior="button_dropdown">
                    <button type="button" className="button-filter med dropdown-toggle">{selectedOption.label}</button>
                    <ul className={menuClassName} role="menu">
                        {options.map((option, index) => (
                            <li key={`select-${option.label}-${option.id}`}>
                                <a onClick={(event) => { this.handleClick(index, option, event); }}>{option.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown-wrapper display-mobile mobile-dropdown">
                    <span className="mobile-arrow" />
                    <select onChange={this.handleChange} value={selectedOption.value} name={name}>
                        {options.map((opt) => (
                            <option
                                value={opt.value || opt.label}
                                key={`selectmobile-${opt.label}-${opt.id}`}
                            >
                                {opt.label}
                            </option>
                            ))}
                    </select>
                </div>
            </span>
        );
    }
}

Select.propTypes = {
    name: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    menuSizeClass: PropTypes.string,
    defaultSelection: PropTypes.number
};

Select.defaultProps = {
    onChange: () => {},
    menuSizeClass: 'med',
    defaultSelection: 0
};

export default Select;



// WEBPACK FOOTER //
// ./app/common/Select.js